import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import * as urls from '../utilities/urls';
import { NzTableData } from '../utilities/nz-table.adapter';
import { MerchantTransactionSearch } from '../models/merchant-transactions';
import { TransactionAccountTypeOptions, UserTypes} from '../utilities/common-file';
import { AuthService } from '../auth/auth.service';
import { TransactionAccountTypes} from '../utilities/common-file';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {

  constructor(private httpClient: HttpClient, private authService: AuthService, private router: Router) { }

  // To Show Updated Location details in grid
  getLocationInfo(value) {
    return this.httpClient.post(urls.LocationUrls.location + urls.LocationUrls.list, value);
  }
  // Merchant daily summary report
getDailyMerchantTransactionsWithLimit(value) {
  const values = {
    startDate: value.startDate,
    endDate: value.endDate ? value.endDate : '',
    accountTypeIn:[TransactionAccountTypes.qrPayment, TransactionAccountTypes.externalPayment, TransactionAccountTypes.refund],
    merchantId: value.merchantId ? value.merchantId : '',
    locationId: value.locationId ? value.locationId : '',
    appCode: value.appCode,
};
  return this.httpClient.post(urls.MerchantSettlementUrls.dailySummary, values);
}
  // To Show Recent 10 transactions in grid
  getTransactionsWithLimit(tableData: NzTableData<MerchantTransactionSearch, any>) {
    const value = {
      merchantId: tableData.search.merchantId ? tableData.search.merchantId : '',
      startDate: tableData.search.createdDate.startDate ? tableData.search.createdDate.startDate : '',
      endDate: tableData.search.createdDate.endDate ? tableData.search.createdDate.endDate : '',
      isSettled: tableData.search.isSettled,
      paymentMethod: tableData.search.paymentMethod ? tableData.search.paymentMethod : '',
      accountTypeIn: tableData.search.accountType ? tableData.search.accountType :
      [TransactionAccountTypes.qrPayment, TransactionAccountTypes.externalPayment, TransactionAccountTypes.settlement,
      TransactionAccountTypes.refund],
      mobileNo: tableData.search.type === 'mobile_no' ? (tableData.search.number ? tableData.search.number.toString() : '') : '',
      accountNo: tableData.search.type === 'account_no' ? tableData.search.number : '',
      name: tableData.search.name,
      locationId: tableData.search.locationId ? tableData.search.locationId : '',
      isOrderDelivered: tableData.search.isOrderDelivered ? tableData.search.isOrderDelivered : '',
      pageSize: tableData.pageSize,
      pageIndex: tableData.pageIndex
  };
    return this.httpClient.post(urls.MerchantTransactionUrls.transactionList, value);
  }
}
